"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableEmptyState = void 0;
var react_1 = __importDefault(require("react"));
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var design_system_buttons_1 = require("@contrast-security-inc/design-system-buttons");
var design_system_typography_1 = require("@contrast-security-inc/design-system-typography");
var css_1 = require("@emotion/css");
var design_system_layouts_1 = require("@contrast-security-inc/design-system-layouts");
var emptyStateStyles = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /**\n    Specifically subtracting <tr> padding\n    top/bottom in the case of future updates,\n    easier for search/replace\n  */\n  margin: calc(100px - 24px) auto;\n  max-width: 450px;\n  text-align: center;\n\n  h3 {\n    margin-bottom: 8px;\n  }\n\n  p {\n    margin-bottom: 12px;\n  }\n\n  > * {\n    margin: 0;\n  }\n"], ["\n  /**\n    Specifically subtracting <tr> padding\n    top/bottom in the case of future updates,\n    easier for search/replace\n  */\n  margin: calc(100px - 24px) auto;\n  max-width: 450px;\n  text-align: center;\n\n  h3 {\n    margin-bottom: 8px;\n  }\n\n  p {\n    margin-bottom: 12px;\n  }\n\n  > * {\n    margin: 0;\n  }\n"])));
var TableEmptyState = function (_a) {
    var _b = _a.bodyText, bodyText = _b === void 0 ? '' : _b, _c = _a.buttonProps, buttonProps = _c === void 0 ? {
        buttonText: '',
    } : _c, _d = _a.colSpan, colSpan = _d === void 0 ? 1 : _d, _e = _a.headerText, headerText = _e === void 0 ? '' : _e, _f = _a.iconProps, iconProps = _f === void 0 ? {} : _f, _g = _a.isErrorState, isErrorState = _g === void 0 ? false : _g, testId = _a.testId;
    var Icon = iconProps.Icon, _h = iconProps.size, iconSize = _h === void 0 ? 'lg' : _h, _j = iconProps.testId, iconTestId = _j === void 0 ? testId : _j, restIconProps = __rest(iconProps, ["Icon", "size", "testId"]);
    var buttonText = buttonProps.buttonText, restButtonProps = __rest(buttonProps, ["buttonText"]);
    var renderIcon = function () {
        if (isErrorState) {
            return react_1.default.createElement(design_system_foundations_1.IconWarning, { size: "lg", color: "neutral80", testId: "".concat(iconTestId, "-warning-icon") });
        }
        if (Icon) {
            return react_1.default.createElement(Icon, __assign({ size: iconSize, testId: iconTestId }, restIconProps));
        }
    };
    return (react_1.default.createElement("tr", { "data-testid": "".concat(testId, "-row-empty") },
        react_1.default.createElement("td", { colSpan: colSpan, "data-testid": "".concat(testId, "-cell-empty") },
            react_1.default.createElement(design_system_layouts_1.Stack, { className: emptyStateStyles, alignItems: "center", flexDirection: "column", spacing: "4px" },
                renderIcon(),
                headerText && (react_1.default.createElement(design_system_typography_1.Text, { font: "titleH3", as: "h3" }, headerText)),
                bodyText && (react_1.default.createElement(design_system_typography_1.Text, { font: "body", as: "p" }, bodyText)),
                buttonText && react_1.default.createElement(design_system_buttons_1.Button, __assign({}, restButtonProps), buttonText)))));
};
exports.TableEmptyState = TableEmptyState;
var templateObject_1;
